import React, { useState } from 'react';
import { connect } from 'react-redux';
import ListAnimation from '../../../utils/animations/list';

const mapStateToProps = (state) => {
	const { rightFeedbackProps, answerCount } = state.rootReducer.testPageDetails;

	return {
		rightFeedbackProps,
		answerCount,
	};
};

const MsCorrect = ({
	rightFeedbackProps: { feedbackChoices, feedbackImageChoices, correctAnswer },
}) => {
	const [showMore, setShowMore] = useState(false);
	let crtChoices = [];
	if (!!correctAnswer) {
		let list = correctAnswer.split('|');
		crtChoices = list.map(function (choice) {
			let TxtImgChoice = choice;
			if (
				!!feedbackImageChoices &&
				!!feedbackImageChoices[choice] &&
				feedbackImageChoices[choice] !== 'None'
			) {
				TxtImgChoice = <img src={feedbackImageChoices[choice]} alt="" />;
			}
			return (
				<li key={choice} className="possible-answer">
					<input
						className="check-field"
						defaultChecked
						type="checkbox"
						name={choice}
						value={choice}
					/>
					<label htmlFor={choice}> {TxtImgChoice}</label>
				</li>
			);
		});
	}

	let moreChoices = '';

	if (!!feedbackChoices) {
		if (!!feedbackChoices && Object.keys(feedbackChoices).length > 0) {
			moreChoices = Object.keys(feedbackChoices).map(function (choice) {
				if (
					feedbackChoices[choice] === '' ||
					correctAnswer
						.toLowerCase()
						.trim()
						.includes(feedbackChoices[choice].toLowerCase().trim())
				) {
					return false;
				}
				let TxtImgChoice = feedbackChoices[choice];
				if (
					feedbackImageChoices[choice] !== '' &&
					feedbackImageChoices[choice] !== 'None'
				) {
					TxtImgChoice = <img src={feedbackImageChoices[choice]} alt="" />;
				}

				return <li key={`more_${choice}`}>{TxtImgChoice}</li>;
			});
		}
	}

	return (
		<span>
			<ListAnimation>
				{' '}
				<ul className="quiz-area-options multiple-ops no-mouse-events">
					{crtChoices}
				</ul>{' '}
			</ListAnimation>
			{showMore && (
				<ListAnimation>
					<ul>{moreChoices}</ul>
				</ListAnimation>
			)}
			{!moreChoices.every((x) => !x) && (
				<button
					onClick={() => setShowMore((x) => !x)}
					className="btn btn-xs btn-info mar-rgt mar-btm pull-right"
				>
					{showMore ? 'View less options' : 'View all options'}
				</button>
			)}
		</span>
	);
};

export default connect(mapStateToProps)(MsCorrect);
